module.exports = __webpack_public_path__ + "images/a05c0ef692c891803fa6a56ffe821009.png";